import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { dsColorNew } from "@palette"
import { AppCategoriesAutocomplete } from "@components/Autocomplete"
import useDsRepricingDataInfo from "Pages/DsRepricing/Page/@hooks/useDataInfo"
import { dsRepricingDrawerData } from "Pages/DsRepricing/Page/@signals"

export default function DsRepricingFilterCategories() {
	const { dataInfo, setDataInfo } = useDsRepricingDataInfo(dsRepricingDrawerData.peek().filterCategories ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useDsRepricingDataInfo(dsRepricingDrawerData.peek().filterCategoriesExclusion ?? false)

	const isExclusion = exclInfo.value

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => setExcl(e.target.checked, 'filterCategoriesExclusion')} size="small"/>
				<Typography sx={{ fontSize: 14, color: dsColorNew.textDark, fontWeight: 500 }}>
					{isExclusion ? 'Exclude categories' : 'Include categories'}
				</Typography>
			</Box>
			<AppCategoriesAutocomplete
				label="Categories"
				placeholder={isExclusion ? 'All categories except…' : 'All categories'}
				value={dataInfo.value ?? []}
				onChange={e => setDataInfo(e.target.value, 'filterCategories')}
			/>
		</Box>
	)
}